export default "__VITE_ASSET__DZ4G_r1U__"